var downloadActions = require('../downloadActions');
var DownloadDialog = require('./DownloadDialog');
var connect = require('react-redux').connect;
var toggleDownloadDialog = require('../../reader/readerActions').toggleDownloadDialog;

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    showPdfProgress: () => dispatch(downloadActions.showPdfProgress()),
    hidePdfProgress: () => dispatch(downloadActions.hidePdfProgress()),
    chapterToPdf: (chapter) => dispatch(downloadActions.chapterToPdf(chapter)),
    setPdfSrc: (pdfsource) => dispatch(downloadActions.setPdfSrc(pdfsource)),
    allChaptersToPdf: (isSelected) => dispatch(downloadActions.allChaptersToPdf(isSelected)),
    toggleDownloadDialog: () => dispatch(toggleDownloadDialog()),
  }
}

const mapStateToProps = (state) => {
  return {
    pubId: state.reader.id,
    expanded: state.reader.downloadDialogExpanded,
    sections: state.reader.sections,
    downloadSrc: state.download.downloadPdfSrc,
    filename: state.reader.filename,
    downloadUrl: state.reader.downloadUrl,
    isPreview: state.reader.isPreview,
    downloadPdfProgess: state.download.downloadPdfProgess,
    downloadFullPdf: state.download.downloadFullPdf,
    selectedChapters: state.download.selectedChapters,
    readerGui: state.reader.readerGui
  }
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(DownloadDialog);



// WEBPACK FOOTER //
// ./src/modules/download/components/DownloadDialogContainer.js